<template>
    <div>
        <h3 v-if="success" class="success">Yo, check your email!</h3>
        <p v-if="success" class="success-sub">
            We sent you a link to reset your password.
        </p>

        <form-with-loader v-if="!success" :form="form" @success="success = true" class="login-form">
            <h3 v-if="!email">Forgot password? Let's reset it.</h3>
            <label v-show="!email">
                <div class="label-text email-label">Email</div>
                <error :error="form.validator.getError('email')"></error>
                <input v-model="form.email" type="email" @focus="shrinkLabel('email-label', $event)" @blur="growLabel('email-label', $event)">
            </label>

            <template slot="button-text">{{ buttonText }}</template>
        </form-with-loader>


    </div>
</template>

<script>
    import VuetifulForm       from 'vuetiful-forms/src/components/VuetifulForm'
    import Error              from 'vuetiful-forms/src/components/Error'
    import ForgotPasswordForm from "../../Forms/ForgotPasswordForm";
    import labelAnimation from "../../../../Lib/Mixins/labelAnimation";
    import FormWithLoader from "../../../../App/Views/Components/FormWithLoader";

    export default {
        name      : "ForgotPassword",
        mixins    : [labelAnimation],
        components: { FormWithLoader, VuetifulForm, Error },

        props: {
            email     : {},
            buttonText: {
                default: 'Tally Ho',
            }
        },

        watch: {
            email: function() {
                this.form.email = this.email;
            }
        },

        data() {
            return {
                form   : new ForgotPasswordForm(this.email),
                success: false,
            }
        },
    }
</script>

<style scoped>
    .success {
        text-align: center;
    }

    .success-sub {
        text-align: center;
        text-transform: none;
        letter-spacing: normal;
        font-size: 18px;
        max-width: 280px;
        line-height: 1.4;
        margin: 0 auto 40px;
    }
</style>
